import CustomHTMLElement from '@onpace/onspace-core/components/html_element'

/// The Onspace Player Selector is a component which allows users to select from a list of media.
export default class OnspacePlayerSelector extends CustomHTMLElement {
  /// Runs when the element is first connected to the DOM.
  runFirstConnected() {
    super.runFirstConnected()

    this.classList.add('onspace-player-selector')
  }

  ////////// Items

  /// Add an item to the selector.
  ///
  /// This accepts an object with the following attributes:
  /// [metadata]
  ///   A player metadata object, see OnspaceMediaPlayer for more information.
  /// [indicatorIcon]
  ///   An optional icon to show as an indicator.
  /// [indicatorText]
  ///   Optional text to show as an indicator.
  /// [action]
  ///   A default action to run when clicked.
  addItem({ metadata, indicatorIcon, indicatorText, action }) {
    const itemElement = document.createElement('div')
    itemElement.classList.add('onspace-player-selector__item')
    itemElement.itemId = metadata.id

    if (action) {
      itemElement.addPressEventListeners({ onPress: action })
    } else {
      itemElement.addPressEventListeners({ onPress: this.itemClicked.bind(this) })
    }

    const imageElement = document.createElement('div')
    imageElement.classList.add('onspace-player-selector__item__image')
    itemElement.appendChild(imageElement)

    if (indicatorIcon) {
      const indicatorElement = SVGElement.createOnspaceSpritemapSvg(indicatorIcon)
      indicatorElement.classList.add('onspace-player-selector__item__indicator')
      imageElement.appendChild(indicatorElement)
    } else if (indicatorText) {
      const indicatorElement = document.createElement('div')
      indicatorElement.classList.add('onspace-player-selector__item__indicator')
      indicatorElement.innerText = indicatorText
      imageElement.appendChild(indicatorElement)
    }

    if (metadata.artwork) {
      imageElement.style.backgroundImage = `url(${metadata.artwork})`
    }

    if (metadata.title) {
      const titleElement = document.createElement('div')
      titleElement.classList.add('onspace-player-selector__item__title')
      titleElement.innerText = metadata.title
      itemElement.appendChild(titleElement)
    }

    if (metadata.subtitle) {
      const subtitleElement = document.createElement('div')
      subtitleElement.classList.add('onspace-player-selector__item__subtitle')
      subtitleElement.innerText = metadata.subtitle
      itemElement.appendChild(subtitleElement)
    }

    this.appendChild(itemElement)
  }

  /// Removes all existing items from the selector.
  clearItems() {
    this.innerHTML = ''
  }

  /// Responds to clicks on an item element.
  itemClicked(event) {
    this.triggerEvent('onspace:media:player-selector:item-clicked', event.target.itemId)
  }

  /// Retrieves the selectable item elements.
  get itemElements() {
    return Array.from(this.children)
  }
}

window.customElements.define('onspace-player-selector', OnspacePlayerSelector)
